import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import Dashboard from "./pages/dashboard/Dashboard";
import Patients from "./pages/patients/Patients";
import Profile from "./pages/profile/Profile";
import Devices from "./pages/devices/Devices";
import Televisite from "./pages/televisite/Televisite";
import Telemonitoraggi from "./pages/telemonitoraggi/Telemonitoraggi";
import Doctors from "./pages/doctors/Doctors";
import Security from "./pages/security/Security";
import ControlRoom from "./pages/controlroom/ControlRoom";
import NotFound from "./pages/notfound/NotFound";
import Login from "./pages/login/Login";
import Layout from "./components/Layout";
import Users from "./pages/users/Users";
import Communications from "./pages/communications/Communications";
import {
  AuthProvider,
  RequireAuth,
  useSignOut,
  useAuthUser,
} from "react-auth-kit";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { ReactQueryDevtools } from "react-query/devtools";
import { QueryClient, QueryClientProvider } from "react-query";
import AxiosInterceptor from "./utils/AxiosInterceptor";
import H3KB from "./pages/H3KB/H3KB";
import axiosInstance from "./utils/AxiosInstance";
import DailyReports from "./pages/dailyreports/DailyReports";
import MonitorAlert from "./pages/monitoralert/MonitorAlert";
import { ToastContainer } from "react-toastify";
import ResetPassword from "./pages/resetpassword/ResetPassword";

function RequireRole(props) {
  const signOut = useSignOut();
  const authUser = useAuthUser();
  const navigate = useNavigate();

  let roleNeeded = props.roleNeeded;

  // user's role allow access
  if (roleNeeded >= authUser()?.role) {
    return props.children;
  } else {
    // sign out, so redirect to login (TODO)
    // (sta provando ad accedere tramite url)
    signOut();
    // navigate('/');
  }
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  dayjs.extend(utc);

  return (
    <div id="app" style={({ height: "100vh" }, { display: "flex" })}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <AuthProvider
          authType={"cookie"}
          authName={"_auth"}
          cookieDomain={window.location.hostname}
          cookieSecure={false}
        >
          <QueryClientProvider client={queryClient}>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Layout />}>
                  <Route index element={<Dashboard />} />
                  <Route
                    path="/patients"
                    element={
                      <RequireAuth loginPath={"/login"}>
                        <Patients />
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="/televisite"
                    element={
                      <RequireAuth loginPath={"/login"}>
                        <Televisite />
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="/telemonitoraggi"
                    element={
                      <RequireAuth loginPath={"/login"}>
                        <Telemonitoraggi />
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="/profile"
                    element={
                      <RequireAuth loginPath={"/login"}>
                        <Profile />
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="/security"
                    element={
                      <RequireAuth loginPath={"/login"}>
                        <Security />
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="/users"
                    element={
                      <RequireAuth loginPath={"/login"}>
                        <RequireRole roleNeeded={2}>
                          <Users />
                        </RequireRole>
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="/communications"
                    element={
                      <RequireAuth loginPath={"/login"}>
                        <Communications />
                      </RequireAuth>
                    }
                  />

                  <Route
                    path="/monitoralert"
                    element={
                      <RequireAuth loginPath={"/login"}>
                        <MonitorAlert />
                      </RequireAuth>
                    }
                  />

                  <Route
                    path="/doctors"
                    element={
                      <RequireAuth loginPath={"/login"}>
                        <RequireRole roleNeeded={2}>
                          <Doctors />
                        </RequireRole>
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="/controlroom"
                    element={
                      <RequireAuth loginPath={"/login"}>
                        <RequireRole roleNeeded={2}>
                          <ControlRoom />
                        </RequireRole>
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="/devices"
                    element={
                      <RequireAuth loginPath={"/login"}>
                        <RequireRole roleNeeded={2}>
                          <Devices filter={null} />
                        </RequireRole>
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="/h3kb"
                    element={
                      <RequireAuth loginPath={"/login"}>
                        <RequireRole roleNeeded={2}>
                          <H3KB />
                        </RequireRole>
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="/dailyreports"
                    element={
                      <RequireAuth loginPath={"/login"}>
                        <DailyReports />
                      </RequireAuth>
                    }
                  />
                  <Route path="/login" element={<Login />} />
                  <Route path="/resetpassword" element={<ResetPassword />} />
                  <Route path="*" element={<NotFound />} />
                </Route>
              </Routes>
            </BrowserRouter>
            <ReactQueryDevtools initialIsOpen={true} />
          </QueryClientProvider>
        </AuthProvider>
      </LocalizationProvider>
    </div>
  );
}

export default App;
